// source: pushwoosh/accounts/accounts.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_annotations_pb = require('../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.Account', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.BillingAddress', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.BillingInfo', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetAccountRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetAccountResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.displayName = 'proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.accounts.BillingAddress.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.BillingAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.BillingAddress.displayName = 'proto.pushwoosh.rpc_v2.accounts.BillingAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.Account = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.Account, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.Account.displayName = 'proto.pushwoosh.rpc_v2.accounts.Account';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetAccountRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetAccountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetAccountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.accounts.BillingInfo.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.BillingInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.BillingInfo.displayName = 'proto.pushwoosh.rpc_v2.accounts.BillingInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.displayName = 'proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.displayName = 'proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateFrom: (f = msg.getDateFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateTo: (f = msg.getDateTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest;
  return proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateFrom(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp date_from = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.prototype.getDateFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest} returns this
*/
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.prototype.setDateFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.prototype.clearDateFrom = function() {
  return this.setDateFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.prototype.hasDateFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp date_to = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.prototype.getDateTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest} returns this
*/
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.prototype.setDateTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.prototype.clearDateTo = function() {
  return this.setDateTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountRequest.prototype.hasDateTo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dailyEmailStat: jspb.Message.getFieldWithDefault(msg, 1, 0),
    monthlyEmailStat: jspb.Message.getFieldWithDefault(msg, 2, 0),
    lastEmailStat: jspb.Message.getFieldWithDefault(msg, 3, 0),
    paidEmailQuota: jspb.Message.getFieldWithDefault(msg, 4, 0),
    freeEmailQuota: jspb.Message.getFieldWithDefault(msg, 5, 0),
    freeEmailLimit: jspb.Message.getFieldWithDefault(msg, 6, 0),
    billingMonthEmailSendsStat: jspb.Message.getFieldWithDefault(msg, 7, 0),
    requestDateEmailStat: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse;
  return proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setDailyEmailStat(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMonthlyEmailStat(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLastEmailStat(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPaidEmailQuota(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFreeEmailQuota(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFreeEmailLimit(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBillingMonthEmailSendsStat(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRequestDateEmailStat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyEmailStat();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getMonthlyEmailStat();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getLastEmailStat();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getPaidEmailQuota();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getFreeEmailQuota();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getFreeEmailLimit();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getBillingMonthEmailSendsStat();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getRequestDateEmailStat();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
};


/**
 * optional uint64 daily_email_stat = 1;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.getDailyEmailStat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.setDailyEmailStat = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 monthly_email_stat = 2;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.getMonthlyEmailStat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.setMonthlyEmailStat = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 last_email_stat = 3;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.getLastEmailStat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.setLastEmailStat = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 paid_email_quota = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.getPaidEmailQuota = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.setPaidEmailQuota = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 free_email_quota = 5;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.getFreeEmailQuota = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.setFreeEmailQuota = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint64 free_email_limit = 6;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.getFreeEmailLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.setFreeEmailLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint64 billing_month_email_sends_stat = 7;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.getBillingMonthEmailSendsStat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.setBillingMonthEmailSendsStat = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint64 request_date_email_stat = 8;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.getRequestDateEmailStat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetEmailStatisticCountResponse.prototype.setRequestDateEmailStat = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateFrom: (f = msg.getDateFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateTo: (f = msg.getDateTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest;
  return proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateFrom(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp date_from = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.prototype.getDateFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest} returns this
*/
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.prototype.setDateFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.prototype.clearDateFrom = function() {
  return this.setDateFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.prototype.hasDateFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp date_to = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.prototype.getDateTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest} returns this
*/
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.prototype.setDateTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.prototype.clearDateTo = function() {
  return this.setDateTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountRequest.prototype.hasDateTo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    monthlyActiveDevices: jspb.Message.getFieldWithDefault(msg, 1, 0),
    calendarMonthlyActiveDevices: jspb.Message.getFieldWithDefault(msg, 2, 0),
    previousMonthActiveDevices: jspb.Message.getFieldWithDefault(msg, 3, 0),
    requestDateActiveDevices: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse;
  return proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMonthlyActiveDevices(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCalendarMonthlyActiveDevices(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPreviousMonthActiveDevices(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRequestDateActiveDevices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMonthlyActiveDevices();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getCalendarMonthlyActiveDevices();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getPreviousMonthActiveDevices();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getRequestDateActiveDevices();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional uint64 monthly_active_devices = 1;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.prototype.getMonthlyActiveDevices = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.prototype.setMonthlyActiveDevices = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 calendar_monthly_active_devices = 2;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.prototype.getCalendarMonthlyActiveDevices = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.prototype.setCalendarMonthlyActiveDevices = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 previous_month_active_devices = 3;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.prototype.getPreviousMonthActiveDevices = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.prototype.setPreviousMonthActiveDevices = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 request_date_active_devices = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.prototype.getRequestDateActiveDevices = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveDevicesCountResponse.prototype.setRequestDateActiveDevices = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    platformsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest;
  return proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPlatforms(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlatformsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      1,
      f
    );
  }
};


/**
 * repeated uint32 platforms = 1;
 * @return {!Array<number>}
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.prototype.getPlatformsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.prototype.setPlatformsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.prototype.addPlatforms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountRequest.prototype.clearPlatformsList = function() {
  return this.setPlatformsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pushEnabled: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pushDisabled: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse;
  return proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPushEnabled(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPushDisabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPushEnabled();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getPushDisabled();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional uint64 push_enabled = 1;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.prototype.getPushEnabled = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.prototype.setPushEnabled = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 push_disabled = 2;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.prototype.getPushDisabled = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetSubscribersCountResponse.prototype.setPushDisabled = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateFrom: (f = msg.getDateFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateTo: (f = msg.getDateTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest;
  return proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateFrom(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp date_from = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.prototype.getDateFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest} returns this
*/
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.prototype.setDateFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.prototype.clearDateFrom = function() {
  return this.setDateFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.prototype.hasDateFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp date_to = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.prototype.getDateTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest} returns this
*/
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.prototype.setDateTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.prototype.clearDateTo = function() {
  return this.setDateTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountRequest.prototype.hasDateTo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    monthlyActiveUsers: jspb.Message.getFieldWithDefault(msg, 1, 0),
    calendarMonthlyActiveUsers: jspb.Message.getFieldWithDefault(msg, 2, 0),
    previousMonthActiveUsers: jspb.Message.getFieldWithDefault(msg, 3, 0),
    requestDateActiveUsers: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse;
  return proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMonthlyActiveUsers(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCalendarMonthlyActiveUsers(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPreviousMonthActiveUsers(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRequestDateActiveUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMonthlyActiveUsers();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getCalendarMonthlyActiveUsers();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getPreviousMonthActiveUsers();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getRequestDateActiveUsers();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional uint64 monthly_active_users = 1;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.prototype.getMonthlyActiveUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.prototype.setMonthlyActiveUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 calendar_monthly_active_users = 2;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.prototype.getCalendarMonthlyActiveUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.prototype.setCalendarMonthlyActiveUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 previous_month_active_users = 3;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.prototype.getPreviousMonthActiveUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.prototype.setPreviousMonthActiveUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 request_date_active_users = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.prototype.getRequestDateActiveUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetActiveUsersCountResponse.prototype.setRequestDateActiveUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest}
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest;
  return proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest}
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeRequest.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    expireAt: (f = msg.getExpireAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse}
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse;
  return proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse}
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpireAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getExpireAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp expire_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.prototype.getExpireAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse} returns this
*/
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.prototype.setExpireAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.prototype.clearExpireAt = function() {
  return this.setExpireAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.SetDebugModeResponse.prototype.hasExpireAt = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest;
  return proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isActive: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    paywallPlan: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    welcomeScreen: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    getStarted: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    showSurvey: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse;
  return proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaywallPlan(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWelcomeScreen(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGetStarted(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowSurvey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPaywallPlan();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getWelcomeScreen();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getGetStarted();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getShowSurvey();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional bool is_active = 1;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool paywall_plan = 2;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.prototype.getPaywallPlan = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.prototype.setPaywallPlan = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool welcome_screen = 3;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.prototype.getWelcomeScreen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.prototype.setWelcomeScreen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool get_started = 4;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.prototype.getGetStarted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.prototype.setGetStarted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool show_survey = 5;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.prototype.getShowSurvey = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetOnboardingInfoResponse.prototype.setShowSurvey = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    plan: jspb.Message.getFieldWithDefault(msg, 1, ""),
    step: jspb.Message.getFieldWithDefault(msg, 2, ""),
    surveyMap: (f = msg.getSurveyMap()) ? f.toObject(includeInstance, proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest;
  return proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlan(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStep(value);
      break;
    case 3:
      var value = msg.getSurveyMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.deserializeBinaryFromReader, "", new proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlan();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStep();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSurveyMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.serializeBinaryToWriter);
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.toObject = function(includeInstance, msg) {
  var f, obj = {
    answersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list;
  return proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAnswers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnswersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string answers = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.prototype.getAnswersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.prototype.setAnswersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.prototype.addAnswers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list.prototype.clearAnswersList = function() {
  return this.setAnswersList([]);
};


/**
 * optional string plan = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.prototype.getPlan = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.prototype.setPlan = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string step = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.prototype.getStep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.prototype.setStep = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<string, answer_list> survey = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list>}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.prototype.getSurveyMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.answer_list));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoRequest.prototype.clearSurveyMap = function() {
  this.getSurveyMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse;
  return proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateOnboardingInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest;
  return proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalEmailSubscribers: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse;
  return proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalEmailSubscribers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalEmailSubscribers();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 total_email_subscribers = 1;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse.prototype.getTotalEmailSubscribers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetTotalEmailSubscribersCountResponse.prototype.setTotalEmailSubscribers = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.repeatedFields_ = [19];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.BillingAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
    firstName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 3, ""),
    companyName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    companyNumber: jspb.Message.getFieldWithDefault(msg, 5, ""),
    industry: jspb.Message.getFieldWithDefault(msg, 6, ""),
    department: jspb.Message.getFieldWithDefault(msg, 7, ""),
    country: jspb.Message.getFieldWithDefault(msg, 8, ""),
    street: jspb.Message.getFieldWithDefault(msg, 9, ""),
    zipCode: jspb.Message.getFieldWithDefault(msg, 10, ""),
    paymentEmail: jspb.Message.getFieldWithDefault(msg, 11, ""),
    vatNumber: jspb.Message.getFieldWithDefault(msg, 12, ""),
    countryCode: jspb.Message.getFieldWithDefault(msg, 13, ""),
    state: jspb.Message.getFieldWithDefault(msg, 14, ""),
    stateCode: jspb.Message.getFieldWithDefault(msg, 15, ""),
    secondaryPersonFirstName: jspb.Message.getFieldWithDefault(msg, 16, ""),
    secondaryPersonLastName: jspb.Message.getFieldWithDefault(msg, 17, ""),
    secondaryPersonEmail: jspb.Message.getFieldWithDefault(msg, 18, ""),
    additionalEmailsList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
    city: jspb.Message.getFieldWithDefault(msg, 20, ""),
    accountCompanyName: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.BillingAddress;
  return proto.pushwoosh.rpc_v2.accounts.BillingAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyNumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndustry(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartment(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreet(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentEmail(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setVatNumber(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setStateCode(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryPersonFirstName(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryPersonLastName(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryPersonEmail(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.addAdditionalEmails(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountCompanyName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.BillingAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCompanyNumber();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIndustry();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDepartment();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStreet();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPaymentEmail();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getVatNumber();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getStateCode();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSecondaryPersonFirstName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSecondaryPersonLastName();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getSecondaryPersonEmail();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getAdditionalEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      19,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getAccountCompanyName();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * optional string first_name = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string last_name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string phone = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string company_name = 4;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string company_number = 5;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getCompanyNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setCompanyNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string industry = 6;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getIndustry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setIndustry = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string department = 7;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getDepartment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setDepartment = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string country = 8;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string street = 9;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getStreet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setStreet = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string zip_code = 10;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string payment_email = 11;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getPaymentEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setPaymentEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string vat_number = 12;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getVatNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setVatNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string country_code = 13;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string state = 14;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string state_code = 15;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getStateCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setStateCode = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string secondary_person_first_name = 16;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getSecondaryPersonFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setSecondaryPersonFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string secondary_person_last_name = 17;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getSecondaryPersonLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setSecondaryPersonLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string secondary_person_email = 18;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getSecondaryPersonEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setSecondaryPersonEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * repeated string additional_emails = 19;
 * @return {!Array<string>}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getAdditionalEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setAdditionalEmailsList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.addAdditionalEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.clearAdditionalEmailsList = function() {
  return this.setAdditionalEmailsList([]);
};


/**
 * optional string city = 20;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string account_company_name = 21;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.getAccountCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingAddress} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingAddress.prototype.setAccountCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.Account.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.Account.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.Account} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.Account.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.Account}
 */
proto.pushwoosh.rpc_v2.accounts.Account.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.Account;
  return proto.pushwoosh.rpc_v2.accounts.Account.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.Account} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.Account}
 */
proto.pushwoosh.rpc_v2.accounts.Account.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.Account.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.Account.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.Account} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.Account.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.Account.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.Account} returns this
 */
proto.pushwoosh.rpc_v2.accounts.Account.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetAccountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetAccountRequest;
  return proto.pushwoosh.rpc_v2.accounts.GetAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetAccountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetAccountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: (f = msg.getAccount()) && proto.pushwoosh.rpc_v2.accounts.Account.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetAccountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetAccountResponse;
  return proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetAccountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetAccountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.accounts.Account;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.Account.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetAccountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.accounts.Account.serializeBinaryToWriter
    );
  }
};


/**
 * optional Account account = 1;
 * @return {?proto.pushwoosh.rpc_v2.accounts.Account}
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.prototype.getAccount = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.Account} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.Account, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.Account|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetAccountResponse} returns this
*/
proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetAccountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetAccountResponse.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: (f = msg.getAccount()) && proto.pushwoosh.rpc_v2.accounts.Account.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest;
  return proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.accounts.Account;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.Account.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.accounts.Account.serializeBinaryToWriter
    );
  }
};


/**
 * optional Account account = 1;
 * @return {?proto.pushwoosh.rpc_v2.accounts.Account}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.prototype.getAccount = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.Account} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.Account, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.Account|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest} returns this
*/
proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountRequest.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: (f = msg.getAccount()) && proto.pushwoosh.rpc_v2.accounts.Account.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse;
  return proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.accounts.Account;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.Account.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.accounts.Account.serializeBinaryToWriter
    );
  }
};


/**
 * optional Account account = 1;
 * @return {?proto.pushwoosh.rpc_v2.accounts.Account}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.prototype.getAccount = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.Account} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.Account, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.Account|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse} returns this
*/
proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateAccountResponse.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.repeatedFields_ = [19];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.BillingInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    firstName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    phone: (f = msg.getPhone()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    companyName: (f = msg.getCompanyName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    companyNumber: (f = msg.getCompanyNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    industry: (f = msg.getIndustry()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    department: (f = msg.getDepartment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    country: (f = msg.getCountry()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    street: (f = msg.getStreet()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    zipCode: (f = msg.getZipCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    paymentEmail: (f = msg.getPaymentEmail()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    vatNumber: (f = msg.getVatNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    countryCode: (f = msg.getCountryCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    state: (f = msg.getState()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    stateCode: (f = msg.getStateCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    secondaryPersonFirstName: (f = msg.getSecondaryPersonFirstName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    secondaryPersonLastName: (f = msg.getSecondaryPersonLastName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    secondaryPersonEmail: (f = msg.getSecondaryPersonEmail()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    additionalEmailsList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
    city: (f = msg.getCity()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.BillingInfo;
  return proto.pushwoosh.rpc_v2.accounts.BillingInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPhone(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCompanyName(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCompanyNumber(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setIndustry(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDepartment(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCountry(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setStreet(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setZipCode(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPaymentEmail(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setVatNumber(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCountryCode(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setState(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setStateCode(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSecondaryPersonFirstName(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSecondaryPersonLastName(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSecondaryPersonEmail(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.addAdditionalEmails(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.BillingInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhone();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCompanyName();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCompanyNumber();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIndustry();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDepartment();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCountry();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStreet();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getZipCode();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPaymentEmail();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getVatNumber();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCountryCode();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getState();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStateCode();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSecondaryPersonFirstName();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSecondaryPersonLastName();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSecondaryPersonEmail();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAdditionalEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      19,
      f
    );
  }
  f = message.getCity();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string first_name = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string last_name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue phone = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getPhone = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setPhone = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearPhone = function() {
  return this.setPhone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasPhone = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue company_name = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getCompanyName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setCompanyName = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearCompanyName = function() {
  return this.setCompanyName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasCompanyName = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue company_number = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getCompanyNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setCompanyNumber = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearCompanyNumber = function() {
  return this.setCompanyNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasCompanyNumber = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue industry = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getIndustry = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setIndustry = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearIndustry = function() {
  return this.setIndustry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasIndustry = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue department = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getDepartment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setDepartment = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearDepartment = function() {
  return this.setDepartment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasDepartment = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue country = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getCountry = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setCountry = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearCountry = function() {
  return this.setCountry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasCountry = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue street = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getStreet = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setStreet = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearStreet = function() {
  return this.setStreet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasStreet = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.StringValue zip_code = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getZipCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setZipCode = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearZipCode = function() {
  return this.setZipCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasZipCode = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.StringValue payment_email = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getPaymentEmail = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setPaymentEmail = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearPaymentEmail = function() {
  return this.setPaymentEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasPaymentEmail = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue vat_number = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getVatNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setVatNumber = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearVatNumber = function() {
  return this.setVatNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasVatNumber = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue country_code = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getCountryCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setCountryCode = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearCountryCode = function() {
  return this.setCountryCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasCountryCode = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.StringValue state = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getState = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setState = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearState = function() {
  return this.setState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasState = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue state_code = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getStateCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setStateCode = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearStateCode = function() {
  return this.setStateCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasStateCode = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.StringValue secondary_person_first_name = 16;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getSecondaryPersonFirstName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 16));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setSecondaryPersonFirstName = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearSecondaryPersonFirstName = function() {
  return this.setSecondaryPersonFirstName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasSecondaryPersonFirstName = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.StringValue secondary_person_last_name = 17;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getSecondaryPersonLastName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 17));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setSecondaryPersonLastName = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearSecondaryPersonLastName = function() {
  return this.setSecondaryPersonLastName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasSecondaryPersonLastName = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.StringValue secondary_person_email = 18;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getSecondaryPersonEmail = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 18));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setSecondaryPersonEmail = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearSecondaryPersonEmail = function() {
  return this.setSecondaryPersonEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasSecondaryPersonEmail = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * repeated string additional_emails = 19;
 * @return {!Array<string>}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getAdditionalEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setAdditionalEmailsList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.addAdditionalEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearAdditionalEmailsList = function() {
  return this.setAdditionalEmailsList([]);
};


/**
 * optional google.protobuf.StringValue city = 20;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.getCity = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 20));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
*/
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.setCity = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.BillingInfo} returns this
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.clearCity = function() {
  return this.setCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.BillingInfo.prototype.hasCity = function() {
  return jspb.Message.getField(this, 20) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest;
  return proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest}
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingInfo: (f = msg.getBillingInfo()) && proto.pushwoosh.rpc_v2.accounts.BillingInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse;
  return proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse}
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.accounts.BillingInfo;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.BillingInfo.deserializeBinaryFromReader);
      msg.setBillingInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.accounts.BillingInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingInfo billing_info = 1;
 * @return {?proto.pushwoosh.rpc_v2.accounts.BillingInfo}
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.prototype.getBillingInfo = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.BillingInfo} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.BillingInfo, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.BillingInfo|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse} returns this
*/
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.prototype.setBillingInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.prototype.clearBillingInfo = function() {
  return this.setBillingInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.GetBillingInfoResponse.prototype.hasBillingInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingInfo: (f = msg.getBillingInfo()) && proto.pushwoosh.rpc_v2.accounts.BillingInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest;
  return proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.accounts.BillingInfo;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.BillingInfo.deserializeBinaryFromReader);
      msg.setBillingInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.accounts.BillingInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingInfo billing_info = 1;
 * @return {?proto.pushwoosh.rpc_v2.accounts.BillingInfo}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.prototype.getBillingInfo = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.BillingInfo} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.BillingInfo, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.BillingInfo|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest} returns this
*/
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.prototype.setBillingInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.prototype.clearBillingInfo = function() {
  return this.setBillingInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoRequest.prototype.hasBillingInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingInfo: (f = msg.getBillingInfo()) && proto.pushwoosh.rpc_v2.accounts.BillingInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse;
  return proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.accounts.BillingInfo;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.accounts.BillingInfo.deserializeBinaryFromReader);
      msg.setBillingInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.accounts.BillingInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingInfo billing_info = 1;
 * @return {?proto.pushwoosh.rpc_v2.accounts.BillingInfo}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.prototype.getBillingInfo = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.accounts.BillingInfo} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.accounts.BillingInfo, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.accounts.BillingInfo|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse} returns this
*/
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.prototype.setBillingInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.prototype.clearBillingInfo = function() {
  return this.setBillingInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.accounts.UpdateBillingInfoResponse.prototype.hasBillingInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.pushwoosh.rpc_v2.accounts);
